import type { FaireProductEntity } from "../../entity_types/product";

export const p_utej5cg7w9: FaireProductEntity = {
  token: "p_utej5cg7w9",
  type: "product",
  name: "Woon Genmaicha Tea",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl:
    "https://cdn.faire.com/fastly/1045b9563e09ee7e1826639c907ba1172915f24df5f8984d58af067b6301775a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3abebf4e368325b538ea7f013daedba56bd51015c0a1a4740a5e01396e388035.jpeg",
    "https://cdn.faire.com/fastly/ca07c445da182a58c348ce0aae81eba172643189edd5a5d71be3d3e3f48d397c.jpeg",
    "https://cdn.faire.com/fastly/2b96d21c4bef30f4e53223256088485bd93f2237732255847d244fbb5568dc01.jpeg",
  ],
  priceDollars: 16,
  description:
    "A unique combination of single origin Sencha green tea and toasted brown rice, all sourced straight from Japan. The Sencha gives the tea light grassy and marine notes, while the toasted rice brings in a roasted and nutty quality.\n\nInstructions: For hot tea, use 1 tsp tea for every 8 oz. of hot water and steep for 4-5 minutes. For cold brew, place 2 tbsp tea in container and add 32 oz of water. Steep for at least 4 hours or overnight, strain and enjoy!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:12.472Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
